import React from "react";
import { Col } from "react-bootstrap";
import * as CONST from "../../../helpers/Constants";

const CprPatientResponse = ({ task }) => {
  return (
    <Col
      md={task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED ? 4 : 6}
      className="py1"
      style={{ background: "#fff" }}
    >
      {task.notes && (
        <div className="cpr-template">
          <b>wellPORTAL Patient Response </b>
          <br />
          {new Date(task.created_at).toLocaleString([], {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })}
          <div dangerouslySetInnerHTML={{ __html: task.notes }} />
          { task.attestation_document && (<>
              <div>
                <a href={task.attestation_document}>Click here to view attestation document</a>
              </div>
            </>)
          }
        </div>
      )}
    </Col>
  );
};

export default CprPatientResponse;
